// removed by extract-text-webpack-plugin
module.exports = {"hidden":"hidden___INLQc","label-header":"label-header___3MK_D","ant-select-selection__placeholder":"ant-select-selection__placeholder___3mw7d"};


//////////////////
// WEBPACK FOOTER
// ./src/theme/global.less
// module id = ANM0
// module chunks = 18